// OEM / ホワイトラベル: partner 由来の外部 URL（zendesk_form_url / support_url /
// chrome_web_store_url 等）をそのまま href に出すと javascript: / data: 等のスキームで
// XSS になりうるため、正当な URL のみを許可するセキュリティ境界。無効なら null を返す
// （リンクを出さない）。
// サーバ側でも https 限定検証しているため、クライアントも https のみに揃える（http: は弾く）。
// SupportLink と拡張DLボタンで同じフィルタを共用する（cursor #366）。
export const toSafeExternalUrl = (
  url: string | null | undefined,
): string | null => {
  if (!url) return null

  try {
    const parsed = new URL(url)
    return parsed.protocol === 'https:' ? parsed.href : null
  } catch {
    return null
  }
}
